import BasePage from './BasePage.js';

/**
 * 資産入力ページ
 */
export default class AssetInputPage extends BasePage {
  #submitHandler;

  render() {
    const html = this.#buildHTML();
    this._container.innerHTML = html;
    this.bindEvents();
    // モバイルでキーボードが出て入力欄が隠れるため無効化
    // this.#focusCashInput();
  }

  bindEvents() {
    // フォームのsubmitイベントをリッスン
    const form = this._container.querySelector('[data-ref="assetForm"]');

    // 既存のイベントリスナーを削除（重複防止のため、boundメソッドを保存）
    if (!this.#submitHandler) {
      this.#submitHandler = (e) => {
        e.preventDefault(); // ページリロード防止
        this.#handleNext();
      };
    }

    // 古いリスナーを削除してから新しいリスナーを追加
    form?.removeEventListener('submit', this.#submitHandler);
    form?.addEventListener('submit', this.#submitHandler);
  }

  #buildHTML() {
    const progress = 33;
    const data = this._app.data;
    const assetCategories = this._app.assetCategories;

    const assetSections = assetCategories.map(section => {
      // 単一項目でlabelがない場合は、タイトルのみ表示してインデントなし
      const isSingleItem = section.items.length === 1 && !section.items[0].label;

      // セクションタイトルに注釈を追加（単一項目でnoteがある場合）
      const sectionNote = isSingleItem && section.items[0].note
        ? `<span class="fs-7 fw-semibold ms-3" style="color: var(--bs-gray-700);">※${section.items[0].note}</span>`
        : '';

      return `
        <div class="mb-6">
          <div class="section-title-bg py-3 px-4 mb-3 fw-bold fs-6 mx-n3 mx-md-0 text-primary">
            ${section.title}${sectionNote}
          </div>
          <div class="px-0">
            ${section.items.map(item => `
              <div class="fv-row mb-3 ${item.label ? 'ms-4' : ''}">
                ${item.label ? `<label class="form-label fs-6 fw-semibold mb-2">${item.label}</label>` : ''}
                <div class="input-group input-group-solid">
                  <input type="number" class="form-control form-control-solid text-end"
                         data-asset-id="${item.id}"
                         placeholder="${item.placeholder}"
                         value="${data.assets[item.id] || ''}"
                         inputmode="numeric"
                         pattern="[0-9]*"
                         step="1" />
                  <span class="input-group-text">万円</span>
                </div>
              </div>
            `).join('')}
          </div>
        </div>
      `;
    }).join('');

    return `
      <form data-ref="assetForm" novalidate>
        <div class="mb-8">
          <div class="progress h-10px mb-3">
            <div class="progress-bar bg-primary" role="progressbar" style="width: ${progress}%"
                 aria-valuenow="${progress}" aria-valuemin="0" aria-valuemax="100"></div>
          </div>
        </div>

        <div class="text-center mb-8">
          <div class="d-flex align-items-center justify-content-center gap-3 mb-3">
            <span class="badge badge-circle badge-primary fs-4 fw-bold">1</span>
            <h3 class="fw-bold mb-0">資産構成の入力</h3>
          </div>
          <p class="mb-2">被相続人（亡くなった方）の資産情報を入力してください</p>
          <p class="fs-7 mb-0">該当しない項目は空欄のままで構いません。金額は万円単位で入力してください。</p>
        </div>

        <div class="mb-8">
          ${assetSections}
        </div>

        <div class="fixed-footer d-flex gap-3">
          <button type="submit" class="btn btn-primary w-100" data-ref="nextBtn">
            次へ進む
            <i class="ki-duotone ki-arrow-right fs-3 ms-1">
              <span class="path1"></span>
              <span class="path2"></span>
            </i>
          </button>
        </div>
      </form>
    `;
  }

  #handleNext() {
    if (this.#validate()) {
      this.#saveData();
      this._app.nextStep();
    }
  }

  #validate() {
    const inputs = this._container.querySelectorAll('[data-asset-id]');

    // 全ての入力欄が空かチェック
    const hasAnyInput = Array.from(inputs).some(input => {
      const value = input.value.trim();
      return value !== '' && value !== '0';
    });

    if (!hasAnyInput) {
      alert('資産情報を1つ以上入力してください。');
      return false;
    }

    return true;
  }

  #saveData() {
    const inputs = this._container.querySelectorAll('[data-asset-id]');
    const assets = {};

    inputs.forEach(input => {
      const assetId = input.getAttribute('data-asset-id');
      assets[assetId] = input.value;
    });

    this._app.updateAssets(assets);
  }

  #focusCashInput() {
    const cashInput = this._container.querySelector('[data-asset-id="cash"]');
    if (cashInput) {
      setTimeout(() => cashInput.focus(), 100);
    }
  }
}
